import React, { useState } from 'react';
import Select from 'react-select';
import './flags.css';

const country = [
  { 
    label: 'Mexico', 
    image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/1920px-Flag_of_Mexico.svg.png',
    value: 'MX', 
  }
];

export default function App() {

  const handleChange = (selectedOption) => {
    const setSelectedOption = selectedOption.value;
  };

  const style = {
    control: base => ({
      ...base,
      height: "52px !important",
      borderRadius: "0.375rem !important",
      boxShadow: "none !important", 
      borderColor: "#c4cbd1 !important",
      "&:hover": {
          borderColor: "#c4cbd1 !important"
      }
      
    })
  };

  return (
    <Select 
    options={country} 
    onChange={handleChange} 
    value={{ value: 'MX', label: 'Mexico', image: 'https://upload.wikimedia.org/wikipedia/commons/thumb/f/fc/Flag_of_Mexico.svg/1920px-Flag_of_Mexico.svg.png' }}
    styles={style}
    formatOptionLabel={country => (
      <div className="containerNac"> 
        <div className="pais">{country.value} {country.label}</div>
        <div className="paisBandera">
          <img className="bandera" src={country.image}/> 
        </div>
      </div>
    )}
    placeholder="Seleccionar nacionalidad"
    />
  );
}